var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-base"},[_c('div',{staticClass:"pages page-static"},[_vm._v("\n    TEST"+_vm._s(_vm.datadesu)+"\n  ")])])}]

export { render, staticRenderFns }